import React, { useState } from 'react';
import { TabView, TabPanel } from 'primereact/tabview';
import { Button } from 'primereact/button';
import useRefundOrders from './hooks/useRefundOrders';
import RefundOrdersTable from './components/RefundOrdersTable';
import RefundOrderDetailDialog from './components/RefundOrderDetailDialog';
import { useLanguage } from '../../../contexts/LanguageContext';

const RefundOrdersPage = () => {
    useLanguage();

    const {
        th,
        activeTabIndex,
        setActiveTabIndex,
        activeTabKey,
        tabConfig,
        orders,
        isLoading,
        refetch
    } = useRefundOrders();

    const [selectedOrder, setSelectedOrder] = useState(null);

    const handleDetailClose = () => {
        setSelectedOrder(null);
    };

    const handleActionComplete = () => {
        setSelectedOrder(null);
        refetch();
    };

    return (
        <div className="card">
            <div className="flex justify-content-between align-items-center mb-3">
                <h3>{th('vehicleRefundOrders.pageTitle')}</h3>
                <Button
                    icon="pi pi-refresh"
                    label={th('vehicleRefundOrders.buttons.refresh')}
                    onClick={refetch}
                />
            </div>

            <TabView
                activeIndex={activeTabIndex}
                onTabChange={(e) => setActiveTabIndex(e.index)}
            >
                {tabConfig.map((tab) => (
                    <TabPanel
                        key={tab.key}
                        header={
                            <span className="flex align-items-center gap-2">
                                <i className={tab.icon}></i>
                                <span>{tab.label}</span>
                            </span>
                        }
                    >
                        <RefundOrdersTable
                            data={orders}
                            loading={isLoading}
                            activeTabKey={activeTabKey}
                            onView={(row) => setSelectedOrder(row)}
                        />
                    </TabPanel>
                ))}
            </TabView>

            {selectedOrder && (
                <RefundOrderDetailDialog
                    visible={!!selectedOrder}
                    order={selectedOrder}
                    onHide={handleDetailClose}
                    onActionComplete={handleActionComplete}
                />
            )}
        </div>
    );
};

export default RefundOrdersPage;
